/// <reference lib="dom" />
export const defaultAPIConfig = {
    baseURL: "https://withorbit.com/api",
};
export const emulatorAPIConfig = {
    ...defaultAPIConfig,
    baseURL: "http://127.0.0.1:5001/metabook-system/us-central1/api",
};
//# sourceMappingURL=apiConfig.js.map